<template>
  <ul
    :class="[$style.content, {
      [$style.contentGrid]: flexLayout,
    }]"
  >
    <li
      v-for="resource in resources"
      :key="resource.id || resource._id"
      :class="[$style.resource, $style.highlightsListItem]"
    >
      <component
        :is="icon"
        v-if="icon"
        :class="$style.icon"
      />
      <a
        :class="$style.resourceLink"
        :href="resource.href"
        rel="noopener noreferrer"
      >
        {{ resource.name }}
      </a>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'HighlightsStyledList',

  props: {
    flexLayout: Boolean,
    icon: {
      type: Object,
      default: undefined,
    },
    resources: {
      type: Array,
      default: () => [],
      validator: value => value.every(d => (
        typeof d.name === 'string' && typeof d.href === 'string'
      )),
    },
  },
};
</script>

<style module>
@import '../../css/sections.css';
@import './css/highlights.css';

@value ( jcGrey, jcGrey800 ) from '~css/brand-colors.css';

.content {
  margin: 0;
  padding-left: 0;
}

.contentGrid {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr;
}

.resource {
  align-items: flex-start;
  display: flex;
  flex: 1;
  margin-bottom: 5px;
}

.contentGrid .resource,
.resource:last-child {
  margin-bottom: 0;
}

.content .resourceLink {
  flex: 1;
  text-align: left;
}

.icon {
  margin-right: 10px;
  width: 24px;
}
</style>
